import { camelCase, mapKeys } from 'lodash'

import { AvailableColorsInCamelCase, AvailableFontsInCamelCase, AvailableGradientsInCamelCase } from './style.types'
import colorsToken from './design-tokens.colors.json'
import fontsToken from './design-tokens.fonts.json'

export const colors = mapKeys(
    Object.assign(
        {},
        ...Object.values(colorsToken.color).flatMap((palette) => {
            return Object.entries(palette).flatMap(([color, colorProps]) => {
                if (colorProps.value) {
                    return { [color]: colorProps.value }
                } else {
                    return Object.entries<{ value: string }>(colorProps).map(([shade, shadeProps]) => {
                        return { [shade]: shadeProps.value }
                    })
                }
            })
        }),
    ),
    (_, key) => {
        return camelCase(key)
    },
) as AvailableColorsInCamelCase

export const fonts = mapKeys(
    Object.assign(
        {},
        ...Object.values(fontsToken.font).flatMap((fonts) => {
            return Object.entries<Record<string, unknown>>(fonts).flatMap(([font, fontProps]) => {
                return { [font]: fontProps.value }
            })
        }),
    ),
    (_, key) => {
        return camelCase(key)
    },
) as AvailableFontsInCamelCase

export const gradients = mapKeys(
    Object.assign(
        {},
        ...Object.values(colorsToken.gradient).flatMap((gradients) => {
            return Object.entries(gradients).flatMap(([gradient, gradientProps]) => {
                return {
                    [gradient]: {
                        angle: gradientProps.value.rotation,
                        color1: gradientProps.value.stops[0].color,
                        color2: gradientProps.value.stops[1].color,
                    },
                } as Record<string, unknown>
            })
        }),
    ),
    (_, key) => {
        return camelCase(key)
    },
) as AvailableGradientsInCamelCase
